export default "__VITE_ASSET__DiTLFWGn__"